/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WishlistRouteImport } from './routes/wishlist'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ProductsRouteImport } from './routes/products'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as CartRouteImport } from './routes/cart'
import { Route as BlogRouteImport } from './routes/blog'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsSlugRouteImport } from './routes/products.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'

const WishlistRoute = WishlistRouteImport.update({
  id: '/wishlist',
  path: '/wishlist',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsRoute = ProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogRoute = BlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProductsSlugRoute = ProductsSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => ProductsRoute,
} as any)
const BlogSlugRoute = BlogSlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => BlogRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRouteWithChildren
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/products': typeof ProductsRouteWithChildren
  '/register': typeof RegisterRoute
  '/wishlist': typeof WishlistRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/products/$slug': typeof ProductsSlugRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRouteWithChildren
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/products': typeof ProductsRouteWithChildren
  '/register': typeof RegisterRoute
  '/wishlist': typeof WishlistRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/products/$slug': typeof ProductsSlugRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/about': typeof AboutRoute
  '/blog': typeof BlogRouteWithChildren
  '/cart': typeof CartRoute
  '/checkout': typeof CheckoutRoute
  '/contact': typeof ContactRoute
  '/login': typeof LoginRoute
  '/products': typeof ProductsRouteWithChildren
  '/register': typeof RegisterRoute
  '/wishlist': typeof WishlistRoute
  '/blog/$slug': typeof BlogSlugRoute
  '/products/$slug': typeof ProductsSlugRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/about'
    | '/blog'
    | '/cart'
    | '/checkout'
    | '/contact'
    | '/login'
    | '/products'
    | '/register'
    | '/wishlist'
    | '/blog/$slug'
    | '/products/$slug'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$slug'
    | '/about'
    | '/blog'
    | '/cart'
    | '/checkout'
    | '/contact'
    | '/login'
    | '/products'
    | '/register'
    | '/wishlist'
    | '/blog/$slug'
    | '/products/$slug'
  id:
    | '__root__'
    | '/'
    | '/$slug'
    | '/about'
    | '/blog'
    | '/cart'
    | '/checkout'
    | '/contact'
    | '/login'
    | '/products'
    | '/register'
    | '/wishlist'
    | '/blog/$slug'
    | '/products/$slug'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SlugRoute: typeof SlugRoute
  AboutRoute: typeof AboutRoute
  BlogRoute: typeof BlogRouteWithChildren
  CartRoute: typeof CartRoute
  CheckoutRoute: typeof CheckoutRoute
  ContactRoute: typeof ContactRoute
  LoginRoute: typeof LoginRoute
  ProductsRoute: typeof ProductsRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  WishlistRoute: typeof WishlistRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wishlist': {
      id: '/wishlist'
      path: '/wishlist'
      fullPath: '/wishlist'
      preLoaderRoute: typeof WishlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products': {
      id: '/products'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof ProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/products/$slug': {
      id: '/products/$slug'
      path: '/$slug'
      fullPath: '/products/$slug'
      preLoaderRoute: typeof ProductsSlugRouteImport
      parentRoute: typeof ProductsRoute
    }
    '/blog/$slug': {
      id: '/blog/$slug'
      path: '/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof BlogSlugRouteImport
      parentRoute: typeof BlogRoute
    }
  }
}

interface BlogRouteChildren {
  BlogSlugRoute: typeof BlogSlugRoute
}

const BlogRouteChildren: BlogRouteChildren = {
  BlogSlugRoute: BlogSlugRoute,
}

const BlogRouteWithChildren = BlogRoute._addFileChildren(BlogRouteChildren)

interface ProductsRouteChildren {
  ProductsSlugRoute: typeof ProductsSlugRoute
}

const ProductsRouteChildren: ProductsRouteChildren = {
  ProductsSlugRoute: ProductsSlugRoute,
}

const ProductsRouteWithChildren = ProductsRoute._addFileChildren(
  ProductsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SlugRoute: SlugRoute,
  AboutRoute: AboutRoute,
  BlogRoute: BlogRouteWithChildren,
  CartRoute: CartRoute,
  CheckoutRoute: CheckoutRoute,
  ContactRoute: ContactRoute,
  LoginRoute: LoginRoute,
  ProductsRoute: ProductsRouteWithChildren,
  RegisterRoute: RegisterRoute,
  WishlistRoute: WishlistRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
